import "es6-promise/auto";

import Vue from "vue";
import VModal from "vue-js-modal";

import axios from "axios";
import VueAxios from "vue-axios";

Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

Vue.use(VueAxios, axios);

import ReservationForm from "../requestForm/reservation_form.vue";

import "../requestForm/lib/vee-validate";

document.addEventListener("DOMContentLoaded", () => {
  const props = JSON.parse(document.getElementById('reservation').dataset.vue);
  const app = new Vue({
    el: "#reservation",
    name: 'Reservation',
    render: h => h(ReservationForm, {
      props: props,
    }),
  });

  VModal.rootInstance = app;
});
